// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AkBsE","question":"styles_question__2L7ls","description":"styles_description__3Jloz"};